import { render } from "./opTableLocal.vue?vue&type=template&id=0fe7340e&ts=true"
import script from "./opTableLocal.vue?vue&type=script&lang=ts"
export * from "./opTableLocal.vue?vue&type=script&lang=ts"

import "./opTableLocal.vue?vue&type=style&index=0&id=0fe7340e&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__